import { ServiceName } from '@models/next/RoutePlan';
import { createStrings } from '@utils/local';

export const dashboardStrings = createStrings({
  ja: {
    title: 'Dashboard',
    seaRapidDelivery: '海上速達便',
    waitingForImportDeclaration: '通関許可待ち',
    waitingForDriverInfo: 'ドライバー情報待ち',
    doAndMoveOut: 'D/O＆出庫',
    customs: '通関',
    delivery: '配車',
    zeroDaysBeforePickupDate: '集荷日当日',
    oneDaysBeforePickupDate: '集荷日前日',
    twoDaysBeforePickupDate: '集荷日前々日',
    customsRequestNotYet: '通関依頼未',
    deliveryRequestNotYet: '配車依頼未',
    customerInstructionNotYet: '顧客指示未',
    schedule: 'スケジュール',
    number: '件数',
    waitingForCS: '担当者待ち',
    invoice: '請求書',
    paymentOverdue: '入金日過ぎる',
    notCreated: '未作成',
    preparing: '準備中...',
    thisPartIsInPreparation: 'この部分は準備中です。',
    casesInCheckOnPickupDate: '集荷当日税関検査案件輸入許可待ち',
    d2dNo: 'D2D番号',
    detail: '詳細',
    seeDetail: '詳しく見る',
    seeMore: 'もっと見る',
    noResult: 'お探しの案件がありません',
    doNoNotGetYet: 'D/O未取得',
    moveOutNotYet: '倉庫搬出未',
  },
});

export const kaijoServices = [ServiceName.Enum.海上速達便];
export const d2dServices = ServiceName.options.filter((s) => s !== ServiceName.enum.海上速達便);
